import { Button, Col, Row, Typography } from 'antd'
import React, { forwardRef, useEffect, useRef, useState } from 'react'
import { authService, customerService, profileService } from '../../services';
import { useLocation, useParams } from 'react-router-dom';
import dayjs from 'dayjs';

const TermAndConditionCustomerPDF = forwardRef(({ user }, ref) => {

  // const [user, setUser] = useState(propUser || [])
  // const location = useLocation();
  // const params = new URLSearchParams(location.search);
  // const encodedData = params.get("data");
  // let decodedData = {};
  // if (encodedData) {
  //   decodedData = JSON.parse(decodeURIComponent(encodedData));
  // }


  return (

    <div ref={ref} className="print-area" style={{ padding: '15px', backgroundColor: "#FFFFFF", }}>
      <Row gutter={24} style={{ display: "flex" }}>
        <Col span={13} style={{ display: "flex", justifyContent: "flex-end", alignItems: "center", textAlign: "center" }}>
          <img src='/images/ctrade-logo.png' style={{ height: 80, width: 140 }} />
        </Col>
      </Row>
      <Row style={{ justifyContent: "center", marginTop: 10 }}>
        <Col span={24} style={{ border: "1px solid #ccc", borderRadius: "8px" }}>
          <Row style={{ justifyContent: "center", backgroundColor: "#ccc", paddingTop: 5 }}>
            <Typography.Title level={2}>Negotiated Rate Agreement</Typography.Title>
          </Row>
          <Row style={{ padding: 30, gap: 20 }}>
            <div style={{ fontSize: '15px', display: "flex", flexDirection: "column" }}>
              <p>
                This contract is made by and between:C TRADE USA INC (As
                SHIPPING/FORWARDING/EXPORTER AGENT ONLY) and {user?.name} on {dayjs(user?.created_at).format("DD-MM-YYYY")} (as a
                shipper) for shipping requirements on agreed price according to email applied
                from the date of services offer / cargo delivered or handled.</p>
              <p>
                TERMS AND CONDITIONS:
              </p>
              <ol style={{ padding: '0 15px 0 45px', listStyleType: "decimal", textAlign: "justify", fontSize: 14 }}>
                <li>
                  Unless otherwise noted, all ocean freight quotations subject to third party/
                  are: valid For 30 days From the date of original quotation, subject to
                  equipment availability, subject to any and all tariff additions, valid at time
                  initial shipment is received. Inland Freight quotations are: subject to third
                  party increases valid at time initial shipment is received, subject to any fuel
                  surcharges valid at time initial shipment is received, subject to weight
                  limitations and weight distribution requirements in accordance with the
                  local and national rules and regulations of the country (ies) of transit,
                  subject to availability of inland carrier at time of booking. Loading, lashing,
                  securing, blocking and bracing of cargo is For shipper's account. Carrier
                  reserves the right to stow cargo in the best interest of the Vessel and in
                  compliance with local, national and international rules, regulations and
                  conventions. On deck shipments at shipper's risk. Dangerous cargo, as
                  defined by 49 CFR or the IMDG Code, is subject to the line's approval at time
                  of booking. Kindly note all vessel dates are subject to changes. Equipment is
                  subject to availability. See C TRADE USA INC ORDER FORM for shipment
                  details to which such rate will apply. Service provided to this NRA is subject
                  to Carrier's governing rules tariff, which is accessible at in compliance with
                  FMC Regulations as provided in 46 CFR 532.7
                </li>
                <li>
                  INSURACE: We advise all our customers to put insurance on their                  shipments as there is no insurance on container.

                </li>
                <li>
                  Customs hold and inspection: C TRADE USA INC will not be responsible For
                  any delay or Costs incurred due to custom investigation or hold. See bill of Lading Terms 1-34 in Rule 8 of carriers governing rules tariff.
                </li>
                <li>
                  RORO: Vehicle shipments should be empty and operational.
                </li>
                <li>
                  PAYMENT: We advise all customers to pay on time as agreed 15 days from
                  the date of invoice. Please allow 3-7 business days before we can process
                  your payment and send you your release. C TRADE USA INC is not
                  responsible For any demurrage or detention occurs at destination due to
                  late payment.
                </li>
                <li>ETA and ETD: Alll dates of sailing and arriving are estimated and C TRADE
                  USA INC will not be responsible for any delay. See bill of Lading Terms 1-34
                  in Rule 8 of carriers governing rules tariff.
                </li>
                <li>
                  Packing List: Customer is responsible for providing C TRADE USA INC a
                  proper packing list of goods to be loaded at customer location. C TRADE
                  USA INC will not be responsible for any fines, Fees and penalties due to
                  failure to provide C TRADE USA INC a proper packing list of goods.
                  Customer will be responsible for Charges incurred due to incorrect packing
                  list.
                </li>
                <li>
                  Declaring Values: C TRADE USA INC requires that the shipper provides
                  values for goods being shipped for Documentary/ Customs purposes.
                  Customer should do their best to provide as accurate information as
                  possible.
                </li>
                <li>
                  CTRADE USA INC WILL NOT REPSONSIBLE FOR ANY DELAY IN RELEASE OF
                  STORAGE OCCURRED ON SHIPMENT ON FACILITATION OF THIRD PARTY.
                </li>
                <li>
                  Customer will be responsible for Charges incurred due to incorrect values or holds caused.
                </li>
                <li>
                  See C TRADE USA INC ORDER FORM for shipment details to which such rate
                  will apply.
                </li>
                <li>
                  Any cause of vessel delay / dates change/custom hold title resulting
                  rollovers/per deim CTRADE USA INC will not be responsible For any
                  additional charges occurs on same.
                </li>
                <li>
                  STORAGE POLICY IS FIRM Storage Policy: 15 Days Free at all Facilities
                  there after $ 10/Day/Car from the Day of receiving in and out charges will be
                  $ 100/. Subject to storage charge
                </li>
                <li>
                  Documentation for Title validation: Customer is responsible to provide the all
                  the relevant documents like BOS, notarized POA, passport copy etc. to Fulfill
                  the US Customs requirement. If customs holds the documents and in case of
                  any rollover CTRADE USA INC will not be responsible.
                </li>
              </ol>
              <p>
                PORT Conditions: CTRADE USA INC will not be responsible in case of any
                unforeseen reason at Houston Port that effects on the Shipping operations.
              </p>
            </div>

          </Row>
          <Row>
            <Col span={22} style={{ textAlign: "right" }}>
              <div style={{ display: "inline-block", fontSize: 14 }}>
                <div style={{ display: "flex", justifyContent: "center", alignItems: "center", height: "100px" }}>
                  <img src={user?.signature} crossOrigin="anonymous"
                    style={{ width: 120, height: 80, textAlign: "center" }} />
                </div>
                <p>Signature __________________________</p>
              </div>
            </Col>
          </Row>
          <Row>
            <Col span={22}>
              <div style={{ display: "flex", justifyContent: "right", alignItems: "right", height: "100px" }}>
                <img src={user?.passport} crossOrigin="anonymous"
                  style={{ width: 120, height: 80, textAlign: "right" }} />
              </div>
            </Col>
          </Row>
        </Col>
        <style>
          {
            `ol li {
        margin-bottom: 15px
      }
      `}
        </style>
      </Row>
      <style>
        {`
@media print {
    @page {
        size: A4;
        margin: 0;
    }

    body {
        margin: 0;
        padding: 0;
    }

    body * {
        visibility: hidden;
    }

    .print-area,
    .print-area * {
        visibility: visible;
    }

    .print-area {
        position: absolute;
        top: 0;
        left: 0;
        page-break-after: avoid;
        page-break-inside: avoid;
    }

    * {
        page-break-inside: avoid !important;
        page-break-after: avoid !important;
    }
}
`}
      </style>

    </div >

  )

})
export default TermAndConditionCustomerPDF
